import React from 'react'
import PropTypes from 'prop-types'

import BoolInput from './BoolInput'
import FloatInput from './FloatInput'
import IntegerInput from './IntegerInput'
import StringInput from './StringInput'
import FloatListInput from './FloatListInput'
import IntegerListInput from './IntegerListInput'
import StringListInput from './StringListInput'
import DeviceSensorInput from './DeviceSensorInput'

export const VariantTypeMapping = Object.freeze({
  bool: { name: 'Boolean', component: BoolInput },
  int: { name: 'Integer', component: IntegerInput },
  float64: { name: 'Float', component: FloatInput },
  string: { name: 'String', component: StringInput },
  '[]int': { name: 'Integer List', component: IntegerListInput },
  '[]float64': { name: 'Float List', component: FloatListInput },
  '[]string': { name: 'String List', component: StringListInput },
  DeviceSensor: { name: 'DeviceSensor', component: DeviceSensorInput },
})

export default class VariantInput extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: undefined,
  }

  onChange = (val) => {
    const { value, onChange } = this.props
    onChange({
      type: value.type,
      value: val,
    })
  }

  render() {
    const { value, ...rest } = this.props
    const props = {
      ...rest,
      value: value.value,
      onChange: this.onChange,
    }

    const type = VariantTypeMapping[value.type]
    if (type) {
      return React.createElement(type.component, { ...props })
    }
    return null
  }
}
